import React from 'react';

function SaintKittsAndNevis(props) {
  return (
    <svg
      {...props}
      width="36"
      height="24"
      viewBox="0 0 36 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_800_124083)">
        <mask
          id="mask0_800_124083"
             style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="36"
          height="24"
        >
          <rect width="36" height="24" fill="white" />
        </mask>
        <g mask="url(#mask0_800_124083)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0V24H36V0H0Z"
            fill="#C51918"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0V24L36 0H0Z"
            fill="#5EAA22"
          />
          <path
            d="M0.882107 28.0053L1.56862 28.6861L2.40009 28.1928L43.1936 3.98928L44.5836 3.16462L43.436 2.02665L37.4501 -3.90899L36.7636 -4.58974L35.9321 -4.09642L-4.86146 20.1071L-6.25138 20.9317L-5.10378 22.0697L0.882107 28.0053Z"
            fill="#272727"
            stroke="#FFD018"
            strokeWidth="2.5"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.5994 16.9183L12.3747 18.813L11.5926 16.6786L9.16022 15.9914L11.1871 14.8907L10.9429 12.6583L12.9433 14.0254L15.0153 13.0045L14.4342 15.2785L16.0965 16.9791L13.5994 16.9183Z"
            fill="#F7FCFF"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M24.8494 10.3651L23.6247 12.2598L22.8426 10.1255L20.4102 9.43822L22.4371 8.33758L22.1929 6.10516L24.1933 7.47226L26.2653 6.45136L25.6842 8.72537L27.3465 10.426L24.8494 10.3651Z"
            fill="#F7FCFF"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_800_124083">
          <rect width="36" height="24" rx="5" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default SaintKittsAndNevis;
